export type StepStatus = {
  complete: boolean;
  disabled: boolean;
  nextEnabled: boolean;
};

/**
 * Helper function to create a Record to track which steps in the wizard are complete and if the next button is enabled for that step
 * @param numberOfSteps the number of steps in the wizard
 * @returns object with keys representing the indeces of the steps and values of { complete: false, nextEnabled: false }
 */
export function createNewStepStatusMap(numberOfSteps: number): Record<number, StepStatus> {
  if (numberOfSteps < 1 || numberOfSteps % 1 !== 0) {
    return {};
  }
  return Object.fromEntries(
    new Array(numberOfSteps)
      .fill(undefined)
      .map((_, index) => [index, { complete: false, disabled: false, nextEnabled: false }])
  );
}

export function findNextActiveStepIndex({
  current,
  stepStatusMap,
}: {
  current: number;
  stepStatusMap: Record<number, StepStatus>;
}) {
  let currentStepIndex = current;

  while (currentStepIndex + 1 === Object.keys(stepStatusMap).length || stepStatusMap[currentStepIndex + 1].disabled) {
    currentStepIndex += 1;
  }
  return currentStepIndex + 1;
}

export function findPreviousActiveStepIndex({
  current,
  stepStatusMap,
}: {
  current: number;
  stepStatusMap: Record<number, StepStatus>;
}) {
  let currentStepIndex = current;

  while (currentStepIndex === 0 || stepStatusMap[currentStepIndex - 1].disabled) {
    currentStepIndex -= 1;
  }
  return currentStepIndex - 1;
}
